"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-userbox"
  }, [_vm.isSelf ? _c('span', {
    staticClass: "kiwi-userbox-selfprofile"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_you')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "kiwi-userbox-header"
  }, [_c('div', {
    staticClass: "kiwi-userbox-avatar"
  }, [_c('UserAvatar', {
    attrs: {
      "user": _vm.user,
      "network": _vm.network,
      "size": "large"
    }
  })], 1), _c('div', {
    staticClass: "kiwi-userbox-userinfo"
  }, [_c('span', {
    staticClass: "kiwi-userbox-nick",
    style: {
      'color': _vm.user.getColour()
    }
  }, [_vm._v(_vm._s(_vm.user.nick))]), _vm.isPremiumAnnounced(_vm.network.id, _vm.user.nick) ? _c('span', {
    staticClass: "kiwi-userbox-premium-badge",
    attrs: {
      "title": "Utente Premium",
      "role": "img",
      "aria-label": "Utente Premium"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('path', {
    staticClass: "kiwi-userbox-premium-badge-seal",
    attrs: {
      "d": "M50.00 4.00A10.2 10.2 0 0 1 67.60 7.50A10.2 10.2 0 0 1 82.53\n                        17.47A10.2 10.2 0 0 1 92.50 32.40A10.2 10.2 0 0 1 96.00 50.00A10.2\n                        10.2 0 0 1 92.50 67.60A10.2 10.2 0 0 1 82.53 82.53A10.2 10.2 0 0 1\n                        67.60 92.50A10.2 10.2 0 0 1 50.00 96.00A10.2 10.2 0 0 1 32.40\n                        92.50A10.2 10.2 0 0 1 17.47 82.53A10.2 10.2 0 0 1 7.50 67.60A10.2\n                        10.2 0 0 1 4.00 50.00A10.2 10.2 0 0 1 7.50 32.40A10.2 10.2 0 0 1\n                        17.47 17.47A10.2 10.2 0 0 1 32.40 7.50A10.2 10.2 0 0 1 50.00 4.00 Z"
    }
  }), _c('path', {
    staticClass: "kiwi-userbox-premium-badge-check",
    attrs: {
      "d": "M31 52 L45 66 L70 38"
    }
  })])]) : _vm._e(), _vm.userMode ? _c('span', {
    staticClass: "kiwi-userbox-modestring"
  }, [_vm._v("+" + _vm._s(_vm.userMode))]) : _vm._e(), _c('span', {
    staticClass: "kiwi-userbox-usermask"
  }, [_vm._v(_vm._s(_vm.user.username) + "@" + _vm._s(_vm.user.host))]), _c('div', {
    staticClass: "kiwi-userbox-badges"
  }, [_vm.isSelf && _vm.simplexAddressDraft ? _c('span', {
    staticClass: "kiwi-userbox-simplex-badge"
  }, [_vm._v("SimpleX")]) : _vm._e(), _vm.isContributor(_vm.network.id, _vm.user.nick) ? _c('span', {
    staticClass: "kiwi-userbox-badge kiwi-userbox-badge--contributor"
  }, [_vm._v(_vm._s(_vm.$t('userbox_contributor')))]) : _vm._e(), _vm.isBot(_vm.network.id, _vm.user.nick) ? _c('span', {
    staticClass: "kiwi-userbox-badge kiwi-userbox-badge--bot"
  }, [_vm._v("BOT")]) : _vm._e(), _vm.user.account ? _c('span', {
    staticClass: "kiwi-userbox-badge kiwi-userbox-badge--registered"
  }, [_vm._v(_vm._s(_vm.$t('userbox_registered')))]) : _vm._e()]), _vm.extraFilterEnabled ? _c('div', {
    staticClass: "kiwi-userbox-custom-basicinfo"
  }, [_vm.getAge ? _c('span', {
    staticClass: "kiwi-userbox-chip"
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getAge) + " anni ")]) : _vm._e(), _vm.getGender ? _c('span', {
    staticClass: "kiwi-userbox-chip",
    class: {
      'kiwi-userbox-chip--donna': _vm.genderCode === 'F'
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getGender) + " ")]) : _vm._e(), _vm.getProvince ? _c('span', {
    staticClass: "kiwi-userbox-chip"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getProvince) + " ")]) : _vm._e()]) : _vm.getAge || _vm.getGender || _vm.getProvince ? _c('div', {
    staticClass: "kiwi-userbox-custom-basicinfo-info"
  }, [_c('span', [_vm._v("Per vedere età e provincia di questo utente, inserisci le tue info (età, ...) all'ingresso")])]) : _vm._e()])]), _vm.pluginUiInfoElements.length ? _vm._l(_vm.pluginUiInfoElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      attrs: {
        "plugin-props": {
          user: _vm.user,
          userbox: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "user": _vm.user,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  }) : _vm.realname ? _c('div', {
    staticClass: "kiwi-userbox-basicinfo"
  }, [_c('span', {
    staticClass: "kiwi-userbox-basicinfo-title"
  }, [_vm._v(_vm._s(_vm.$t('whois_realname')) + ":")]), _c('span', {
    staticClass: "kiwi-userbox-basicinfo-data",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedRealname)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "kiwi-userbox-simplex u-form"
  }, [_vm.isSelf ? [_c('div', {
    staticClass: "kiwi-userbox-simplex-heading"
  }, [_c('button', {
    staticClass: "kiwi-userbox-simplex-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.showOwnSimplex
    },
    on: {
      "click": function click($event) {
        _vm.showOwnSimplex = !_vm.showOwnSimplex;
      }
    }
  }, [_c('strong', [_vm._v("Il tuo contatto SimpleX")]), _c('i', {
    class: _vm.showOwnSimplex ? 'fa fa-chevron-up' : 'fa fa-chevron-down',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-userbox-simplex-info-button",
    attrs: {
      "type": "button",
      "title": "Che cos’è SimpleX Chat?",
      "aria-label": "Che cos’è SimpleX Chat?"
    },
    on: {
      "click": function click($event) {
        _vm.showSimplexInfo = !_vm.showSimplexInfo;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm.showSimplexInfo ? _c('div', {
    staticClass: "kiwi-userbox-simplex-info"
  }, [_c('p', [_vm._v(" SimpleX Chat è un’app anonima e gratuita per parlare in modo più privato. È disponibile su Android e iPhone e, a differenza di Telegram, non richiede un numero di telefono né un nome utente pubblico. ")])]) : _vm._e(), _vm.showOwnSimplex ? _c('div', [_c('p', [_vm._v("Condividi il tuo contatto anonimo con gli altri utenti.")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.simplexAddressDraft,
      expression: "simplexAddressDraft"
    }],
    staticClass: "u-input",
    attrs: {
      "type": "url",
      "placeholder": "https://simplex.chat/contact/..."
    },
    domProps: {
      "value": _vm.simplexAddressDraft
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.saveOwnSimplexAddress.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.simplexAddressDraft = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "u-button u-button-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveOwnSimplexAddress
    }
  }, [_vm._v(" Salva ")]), !_vm.simplexAddressDraft ? _c('div', {
    staticClass: "kiwi-userbox-simplex-downloads"
  }, [_c('span', [_vm._v("Scarica SimpleX Gratis")]), _c('a', {
    staticClass: "kiwi-userbox-simplex-store-link",
    attrs: {
      "href": _vm.simplexLinks.ios,
      "target": "_blank",
      "rel": "noopener",
      "title": "Scarica SimpleX per iPhone",
      "aria-label": "Scarica SimpleX per iPhone"
    }
  }, [_c('i', {
    staticClass: "fa fa-apple",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('a', {
    staticClass: "kiwi-userbox-simplex-store-link",
    attrs: {
      "href": _vm.simplexLinks.android,
      "target": "_blank",
      "rel": "noopener",
      "title": "Scarica SimpleX per Android",
      "aria-label": "Scarica SimpleX per Android"
    }
  }, [_c('i', {
    staticClass: "fa fa-android",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm.simplexMessage ? _c('span', {
    staticClass: "kiwi-userbox-simplex-message"
  }, [_vm._v(_vm._s(_vm.simplexMessage))]) : _vm._e()]) : _vm._e()] : _vm.simplexAddress ? [_c('div', {
    staticClass: "kiwi-userbox-simplex-heading"
  }, [_c('button', {
    staticClass: "kiwi-userbox-simplex-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.showRemoteSimplex
    },
    on: {
      "click": function click($event) {
        _vm.showRemoteSimplex = !_vm.showRemoteSimplex;
      }
    }
  }, [_c('strong', [_vm._v("Contatto SimpleX")]), _c('i', {
    class: _vm.showRemoteSimplex ? 'fa fa-chevron-up' : 'fa fa-chevron-down',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-userbox-simplex-info-button",
    attrs: {
      "type": "button",
      "title": "Che cos’è SimpleX Chat?",
      "aria-label": "Che cos’è SimpleX Chat?"
    },
    on: {
      "click": function click($event) {
        _vm.showSimplexInfo = !_vm.showSimplexInfo;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm.showSimplexInfo ? _c('div', {
    staticClass: "kiwi-userbox-simplex-info"
  }, [_c('p', [_vm._v(" SimpleX Chat è un’app anonima e gratuita per parlare in modo più privato. È disponibile su Android e iPhone e, a differenza di Telegram, non richiede un numero di telefono né un nome utente pubblico. ")])]) : _vm._e(), _vm.showRemoteSimplex ? _c('div', {
    staticClass: "kiwi-userbox-simplex-resources"
  }, [_c('p', [_vm._v("Questo utente è disponibile anche su SimpleX Chat.")]), _c('button', {
    staticClass: "u-button u-button-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyAddress
    }
  }, [_vm._v(" " + _vm._s(_vm.addressCopied ? 'Indirizzo copiato' : 'Copia indirizzo') + " ")]), _c('button', {
    staticClass: "u-button u-button-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openAddress
    }
  }, [_vm._v(" Apri in SimpleX ")])]) : _vm._e()] : [_c('div', {
    staticClass: "kiwi-userbox-simplex-heading"
  }, [_c('button', {
    staticClass: "kiwi-userbox-simplex-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.showOtherSimplex
    },
    on: {
      "click": function click($event) {
        _vm.showOtherSimplex = !_vm.showOtherSimplex;
      }
    }
  }, [_c('strong', [_vm._v("Contatto SimpleX Chat")]), _c('i', {
    class: _vm.showOtherSimplex ? 'fa fa-chevron-up' : 'fa fa-chevron-down',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-userbox-simplex-info-button",
    attrs: {
      "type": "button",
      "title": "Che cos’è SimpleX Chat?",
      "aria-label": "Che cos’è SimpleX Chat?"
    },
    on: {
      "click": function click($event) {
        _vm.showSimplexInfo = !_vm.showSimplexInfo;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm.showSimplexInfo ? _c('div', {
    staticClass: "kiwi-userbox-simplex-info"
  }, [_c('p', [_vm._v(" SimpleX Chat è un’app anonima e gratuita per parlare in modo più privato. È disponibile su Android e iPhone e, a differenza di Telegram, non richiede un numero di telefono né un nome utente pubblico. ")])]) : _vm._e(), _vm.showOtherSimplex ? _c('div', {
    staticClass: "kiwi-userbox-simplex-resources"
  }, [_vm.canRequestSimplex ? _c('button', {
    staticClass: "u-button u-button-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.requestSimplexAddress
    }
  }, [_vm._v(" Richiedi Contatto " + _vm._s(_vm.user.nick) + " ")]) : _c('span', {
    staticClass: "kiwi-userbox-simplex-message"
  }, [_vm._v(" Imposta il tuo contatto SimpleX nel tuo profilo per inviare una richiesta. "), _c('button', {
    staticClass: "kiwi-userbox-simplex-profile-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openOwnSimplexProfile
    }
  }, [_vm._v("Apri il mio profilo")])]), _vm.simplexMessage ? _c('span', {
    staticClass: "kiwi-userbox-simplex-message"
  }, [_vm._v(_vm._s(_vm.simplexMessage))]) : _vm._e(), _c('div', {
    staticClass: "kiwi-userbox-simplex-community-section"
  }, [_c('button', {
    staticClass: "kiwi-userbox-action kiwi-userbox-simplex-community-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.showCommunityInviteInfo = !_vm.showCommunityInviteInfo;
      }
    }
  }, [_vm._v("🔒 Gruppo Privato Chat Gratis")]), _vm.showCommunityInviteInfo ? _c('span', {
    staticClass: "kiwi-userbox-simplex-community-info"
  }, [_vm._v("Accesso solo su Invito, richiedilo ad un Moderatore di Chat Gratis")]) : _vm._e()])]) : _vm._e(), !_vm.canRequestSimplex ? _c('div', {
    staticClass: "kiwi-userbox-simplex-downloads kiwi-userbox-simplex-downloads-footer"
  }, [_c('span', [_vm._v("Scarica SimpleX Gratis")]), _c('a', {
    staticClass: "kiwi-userbox-simplex-store-link",
    attrs: {
      "href": _vm.simplexLinks.ios,
      "target": "_blank",
      "rel": "noopener",
      "title": "Scarica SimpleX per iPhone",
      "aria-label": "Scarica SimpleX per iPhone"
    }
  }, [_c('i', {
    staticClass: "fa fa-apple",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('a', {
    staticClass: "kiwi-userbox-simplex-store-link",
    attrs: {
      "href": _vm.simplexLinks.android,
      "target": "_blank",
      "rel": "noopener",
      "title": "Scarica SimpleX per Android",
      "aria-label": "Scarica SimpleX per Android"
    }
  }, [_c('i', {
    staticClass: "fa fa-android",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]], 2), _c('div', {
    staticClass: "kiwi-userbox-actions"
  }, [_vm.isSelf ? _c('a', {
    staticClass: "kiwi-userbox-action",
    on: {
      "click": _vm.setAvatar
    }
  }, [_c('i', {
    staticClass: "fa fa-camera",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('input', {
    staticStyle: {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "ImgurUploader",
      "type": "file",
      "accept": ".webp,.jpg,.jpeg,.png,.gif,.apng,.tiff"
    },
    on: {
      "change": function change($event) {
        return _vm.uploadImage($event);
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('set_avatar')) + " ")]) : _vm._e(), !_vm.isSelf && !_vm.buffer.isQuery() ? _c('a', {
    staticClass: "kiwi-userbox-action",
    on: {
      "click": _vm.openQuery
    }
  }, [_c('i', {
    staticClass: "fa fa-comment",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('send_a_message')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "kiwi-userbox-actions kiwi-userbox-plugin-actions"
  }, _vm._l(_vm.pluginUiButtonElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      attrs: {
        "plugin-props": {
          user: _vm.user,
          userbox: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "user": _vm.user,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  }), 1)]), _c('div', {
    staticClass: "kiwi-userbox-query-invite kiwi-userbox-actions u-form",
    attrs: {
      "id": "query-invite-embed"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasAccount(_vm.network.id, _vm.user.nick),
      expression: "!hasAccount(network.id, user.nick)"
    }],
    staticClass: "kiwi-userbox-plugin",
    attrs: {
      "id": "registerPlugin",
      "aria-hidden": "true",
      "title": "Invitalo a Registrarsi"
    },
    on: {
      "click": function click($event) {
        return _vm.invite($event, _vm.user.nick);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Invitalo a Registrarsi ")])]), !_vm.isSelf ? _c('form', {
    staticClass: "u-form kiwi-userbox-ignoreuser"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.ignore,
      expression: "user.ignore"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.ignore) ? _vm._i(_vm.user.ignore, null) > -1 : _vm.user.ignore
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.user.ignore,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.user, "ignore", (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context;
            $$i > -1 && _vm.$set(_vm.user, "ignore", (0, _concat.default)(_context = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.$set(_vm.user, "ignore", $$c);
        }
      }
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('ignore_user')) + " ")])])]) : _vm._e(), _vm.whoisRequested ? _c('div', {
    staticClass: "kiwi-userbox-whois",
    class: [_vm.whoisLoading ? 'kiwi-userbox-whois--loading' : '']
  }, [_vm.whoisLoading ? [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })] : _vm.pluginUiWhoisElements.length ? _vm._l(_vm.pluginUiWhoisElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      attrs: {
        "plugin-props": {
          user: _vm.user,
          userbox: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "user": _vm.user,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  }) : [_c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.user.away ? _vm.$t('whois_status') + ': ' + _vm.user.away : _vm.$t('whois_status_available')) + " ")]), _vm.user.account ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_account', {
    user: _vm.user.account
  })) + " ")]) : _vm._e(), _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_realname', {
    realname: _vm.user.realname
  })) + " ")]), _vm.user.whois.bot ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_bot')) + " ")]) : _vm._e(), _vm.user.whois.helpop ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_help')) + " ")]) : _vm._e(), _vm.user.whois.operator ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_op')) + " ")]) : _vm._e(), _vm.user.whois.server ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_server', {
    server: _vm.user.whois.server,
    info: _vm.user.whois.server_info ? "(".concat(_vm.user.whois.server_info, ")") : ''
  })) + " ")]) : _vm._e(), _vm.user.whois.secure ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_secure')) + " ")]) : _vm._e(), _vm.user.whois.channels ? _c('span', {
    staticClass: "kiwi-userbox-whois-line",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('user_channels', {
        channels: _vm.userChannels
      }))
    },
    on: {
      "click": function click($event) {
        return _vm.onChannelsClick($event);
      }
    }
  }) : _vm._e()]], 2) : _vm._e(), _vm.buffer.isChannel() && _vm.areWeAnOp && !_vm.isSelf ? _c('div', {
    staticClass: "kiwi-userbox-opactions"
  }, [_c('form', {
    staticClass: "u-form",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.isUserOnBuffer ? _c('label', [_vm._v(" " + _vm._s(_vm.$t('user_access')) + " "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userMode,
      expression: "userMode"
    }],
    on: {
      "change": function change($event) {
        var _context2;
        var $$selectedVal = (0, _map.default)(_context2 = (0, _filter.default)(Array.prototype).call($event.target.options, function (o) {
          return o.selected;
        })).call(_context2, function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.userMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_vm._l(_vm.availableChannelModes, function (mode) {
    return _c('option', {
      key: mode.mode,
      domProps: {
        "value": mode.mode
      }
    }, [_vm._v(" " + _vm._s(mode.description) + " ")]);
  }), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('user_normal')))])], 2)]) : _vm._e(), _vm.isUserOnBuffer ? _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary kiwi-userbox-opaction-kick kiwi-userbox-opaction",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.buffer.kickUser(_vm.user);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user_kick')) + " ")])]) : _vm._e(), _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary kiwi-userbox-opaction-ban kiwi-userbox-opaction",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.buffer.banUser(_vm.user);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user_ban')) + " ")])]), _vm.isUserOnBuffer ? _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary kiwi-userbox-opaction-kickban kiwi-userbox-opaction",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.buffer.banKickUser(_vm.user);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user_kickban')) + " ")])]) : _vm._e()])]) : _vm._e(), _vm.buffer.isQuery() && _vm.invitableBuffers.length > 0 ? _c('div', {
    staticClass: "kiwi-userbox-query-invite kiwi-userbox-actions u-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inviteChan,
      expression: "inviteChan"
    }],
    staticClass: "u-input",
    on: {
      "change": function change($event) {
        var _context3;
        var $$selectedVal = (0, _map.default)(_context3 = (0, _filter.default)(Array.prototype).call($event.target.options, function (o) {
          return o.selected;
        })).call(_context3, function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.inviteChan = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('select_channel')))]), _vm._l(_vm.invitableBuffers, function (chan) {
    return _c('option', {
      key: 'inviteChan-' + chan,
      domProps: {
        "value": chan
      }
    }, [_vm._v(_vm._s(chan))]);
  })], 2), _c('a', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": function click($event) {
        return _vm.inviteUser();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('invite_user')) + " ")])]) : _vm._e()], 2);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;